const itemConfig = {
  label: "TrackaConnect",
  resourceEndpoint: "items",
  isNotContent: true,
  overrideTitle: "Card/Book",
  listMetadata: [
    "type",
    "title",
    "start_number",
    "end_number",
    "message_prompt",
    "actions",
  ],
  keepListMetadataOrder: true,
  searchKeys: ["title"],
  detailsMetadata: [
    {
      name: "type",
      label: "Item Type (Card, Book/Video)",
      validations: [{ type: "required", params: ["Required"] }],
    },
    {
      name: "title",
      label: "Name / Title",
      validations: [{ type: "required", params: ["Required"] }],
    },
    {
      name: "start_number",
      label: "Start Number",
      validations: [{ type: "required", params: ["Required"] }],
    },
    {
      name: "end_number",
      label: "End Number",
      validations: [{ type: "required", params: ["Required"] }],
    },
    { name: "video_url", label: "Video URL" },
    { name: "image_url", label: "Image URL" },
    {
      name: "cta_type",
      label: ""
    },
    {
      name: "action_bar_text",
      label: "Call to Action Text",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "action_bar_text_enterprise",
      label: "Launch Business Call to Action Text",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "action_bar_url",
      label: "Call to Action URL",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "enterprise_app",
      label: "Which Business?",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "cta",
      label: "Call to Action Name List",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return relativeField.value === "Preset CTA";
          },
        },
      ],
    },
    { name: "message_prompt", label: "Message Prompt" },
   
  ],
  formLayout: {
    columns: [
      ["type", "title", "start_number", "end_number", "video_url"],
      [
        "image_url",
        "cta_type",
        "action_bar_text",
        "action_bar_text_enterprise",
        "action_bar_url",
        "enterprise_app",
        "cta",
        "message_prompt",
      ],
    ],
  },
};

export default itemConfig
